<template>
  <div id="bookingConfirmation">
    <div class="ui white raised top attached padded segment" style="color: #000000">
      <div class="ui grid">
        <div class="nine wide column" style="border-right: 1px solid #e8e8e8">
          <h4>{{ createdReservation.contact.title }} {{ createdReservation.contact.firstName }} {{ createdReservation.contact.lastName }}</h4>
          <p>
            <span v-if="createdReservation.contact.company">{{ $t('Company') }}: {{ createdReservation.contact.company }}<br></span>
            {{ $t('Email') }}: {{ createdReservation.contact.email }}<br>
            {{ $t('Telephone') }}: {{ createdReservation.contact.tel }}<br>
            {{ $t('Address') }}: {{ createdReservation.contact.address }}<br>
            {{ $t('City') }}: {{ createdReservation.contact.city }}, {{ createdReservation.contact.zip }}
          </p>
          <p>
            {{ $t('People') }}: <strong>{{ createdReservation.people }}</strong>
          </p>
        </div>
        <div class="seven wide column center aligned middle aligned">
          <h3><strong>{{ createdReservation.code }}</strong></h3>
          <div>Reservation Code</div>
        </div>
      </div>

    </div>
    <table class="ui bottom attached basic white table" style="background: #ffffff">
      <tbody>
      <tr v-for="booking in createdReservation.bookings">
        <td>
          {{ booking.boat.name }}
        </td>
        <td>
          <span v-if="booking.boat.startsAtHalfHour">
            {{ (parseInt(booking.hour.split(' - ')[0]) - 1) + ':30' }} - {{ (parseInt(booking.hour.split(' - ')[1]) - 1) + ':30' }} h
          </span>
          <span v-else>
            {{ booking.hour }} h
          </span>
        </td>
        <td>
          {{ moment(booking.date).format('ll') }}
        </td>
        <td class="right aligned">
          €{{ booking.cost }}.00
        </td>
      </tr>
      <tr v-if="createdReservation.discount">
        <td colspan="4"><strong>Voucher:</strong> {{ createdReservation.discount.voucher }}</td>
      </tr>
      <tr v-if="createdReservation.discount && createdReservation.discount.absolute > 0">
        <td colspan="3"></td>
        <td class="right aligned">- €{{ createdReservation.discount.absolute }}.00</td>
      </tr>
      <tr v-if="createdReservation.discount && createdReservation.discount.percentage > 0">
        <td colspan="3"></td>
        <td class="right aligned">- {{ createdReservation.discount.percentage * 100 }}%</td>
      </tr>
      </tbody>
      <!--<tfoot>-->
      <tr>
        <td colspan="3"><strong>Total</strong></td>
        <td class="right aligned">
          <strong>€{{ numeral(totalCost).format('0,0.00') }}</strong>
        </td>
      </tr>
      <!--</tfoot>-->
      <tr v-if="createdReservation.services.length > 0">
        <td colspan="4">
          <strong>{{ $t('Additional Services') }}</strong>
        </td>
      </tr>
      <tr v-for="service in createdReservation.services" v-if="service.selected">
        <td colspan="3">
          {{ service.title }}<!--<span v-if="service.priceType === 'perPerson'">/ pro Person</span>-->
        </td>
        <td class="right aligned">
          <span v-if="service.priceType === 'perPerson'">p.P. €{{ numeral(service.price).format('0,0.00') }}</span>
          <span v-else>€{{ numeral(service.price).format('0,0.00') }}</span>
        </td>
      </tr>
      <tr v-if="createdReservation.wishes">
        <td colspan="4">
          <strong>{{ $t('Additional Wishes') }}</strong>
        </td>
      </tr>
      <tr v-if="createdReservation.wishes">
        <td colspan="4">
          {{ createdReservation.wishes }}
        </td>
      </tr>
      <tr v-if="createdReservation.questions">
        <td colspan="4">
          <strong>{{ $t('Questions') }}</strong>
        </td>
      </tr>
      <tr v-if="createdReservation.questions">
        <td colspan="4">
          {{ createdReservation.questions }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
  export default {
    props: [
      'createdReservation'
    ],
    computed: {
      totalCost() {
        if (!this.createdReservation || !this.createdReservation.bookings) return this.createdReservation.cost

        return Number(this.createdReservation.bookings.map(b => Number(b.cost)).reduce((a, b) => (a + b)))
      }
    },
    data() {
      return {
        'moment': moment,
        'numeral': numeral,
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// BookingConfirmation.vue?4ae4789e